import { CLIENT_FORM } from '@common/schema/flow';
import { FLOW_PIPE } from '@util/constants';

export const savePersonalInformation = (values: any) => {
  let b2cNotes = '';
  let skillList;

  if (values[CLIENT_FORM.FULL_NAME]) {
    b2cNotes += `${CLIENT_FORM.FULL_NAME} ${FLOW_PIPE.ITEM} ${
      values[CLIENT_FORM.FULL_NAME]
    } ${FLOW_PIPE.LIST} \n`;
  }

  if (values[CLIENT_FORM.EMAIL]) {
    b2cNotes += `${CLIENT_FORM.EMAIL} ${FLOW_PIPE.ITEM} ${
      values[CLIENT_FORM.EMAIL]
    } ${FLOW_PIPE.LIST} \n`;
  }

  if (values[CLIENT_FORM.PHONE_NUMBER]) {
    b2cNotes += `${CLIENT_FORM.PHONE_NUMBER} ${FLOW_PIPE.ITEM} ${
      values[CLIENT_FORM.PHONE_NUMBER]
    }`;
  }
  return {
    b2cNotes,
    skillList,
  };
};
